import { render } from "./jxsshenqing.vue?vue&type=template&id=5023b064"
import script from "./jxsshenqing.vue?vue&type=script&lang=js"
export * from "./jxsshenqing.vue?vue&type=script&lang=js"

import "./jxsshenqing.vue?vue&type=style&index=0&id=5023b064&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__